import {
  EditBlockColorPicker,
  EditBlockSelect,
  EditBlockUpload,
} from '@components/EditBuildingBlocks/all'
import genericContentItemEditor
  from '@components/mixins/genericContentItemEditor'

export default {
  name: 'ImageEditorComponent',
  mixins: [genericContentItemEditor],
  components: {
    'edit-block-select': EditBlockSelect,
    'edit-block-color-picker': EditBlockColorPicker,
    'edit-block-upload': EditBlockUpload,
  },
  computed: {
    imageUrl: {
      get() {
        return this.component.content.url
      },
      set(value) {
        if (this.isGlobalContentItem) {
          this.updateGlobalContentItem({
            id: this.component.id,
            itemName: ['sideImage'],
            path: ['content'],
            attribute: ['url'],
            data: value,
          })
        } else {
          this.updateContentItem({
            id: this.component.id,
            path: ['content'],
            attribute: ['url'],
            data: value,
          })
        }
      },
    },
    imageBackgroundColor: {
      get() {
        return this.component.styling.backgroundColor
      },
      set(value) {
        if (this.isGlobalContentItem) {
          this.updateGlobalContentItem({
            id: this.component.id,
            itemName: ['sideImage'],
            path: ['styling'],
            attribute: ['backgroundColor'],
            data: value,
          })
        } else {
          this.updateContentItem({
            id: this.component.id,
            path: ['styling'],
            attribute: ['backgroundColor'],
            data: value,
          })
        }
      },
    },
    imageBackgroundSize: {
      get() {
        return this.component.styling.backgroundSize
      },
      set(value) {
        if (this.isGlobalContentItem) {
          this.updateGlobalContentItem({
            id: this.component.id,
            itemName: ['sideImage'],
            path: ['styling'],
            attribute: ['backgroundSize'],
            data: value,
          })
        } else {
          this.updateContentItem({
            id: this.component.id,
            path: ['styling'],
            attribute: ['backgroundSize'],
            data: value,
          })
        }
      },
    },
  },
}
